import { defineStore } from 'pinia';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

let unsubscribeFn = null;

export const useGoogleReviewsStore = defineStore('googleReviews', {
  state: () => ({
    data: null,
    loading: false,
    error: ''
  }),
  persist: { paths: ['data'] },
  getters: {
    hasReviews(state) {
      const d = state.data;
      return d && (d.reviews?.length > 0 || d.rating != null);
    }
  },
  actions: {
    subscribe() {
      if (unsubscribeFn) return;
      this.loading = true;
      this.error = '';
      const ref = doc(firestore, 'config', 'googleReviews');
      unsubscribeFn = onSnapshot(
        ref,
        (snap) => {
          this.loading = false;
          this.error = '';
          if (snap.exists()) {
            const raw = snap.data();
            this.data = {
              rating: raw.rating ?? null,
              userRatingCount: raw.userRatingCount ?? null,
              reviews: Array.isArray(raw.reviews) ? raw.reviews : []
            };
          } else {
            this.data = null;
          }
        },
        () => {
          this.loading = false;
          this.error = 'Não foi possível carregar as avaliações.';
          this.data = null;
        }
      );
    },
    unsubscribe() {
      if (unsubscribeFn) {
        unsubscribeFn();
        unsubscribeFn = null;
      }
    }
  }
});
